const LEAD_INFO_EXPIRY_DAYS = 30;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const loadSavedLeadInfo = () => {
  try {
    const savedData = localStorage.getItem('leadInfo');
    if (!savedData) {
      return null;
    }

    const parsed = JSON.parse(savedData);
    const now = new Date().getTime();

    if (parsed.expiresAt && now > parsed.expiresAt) {
      localStorage.removeItem('leadInfo');
      return null;
    }

    return parsed.data;
  } catch (error) {
    console.error('Error loading saved lead info:', error);
    return null;
  }
};

export const saveLeadInfoToStorage = (leadData) => {
  try {
    const now = new Date().getTime();
    const expiresAt = now + LEAD_INFO_EXPIRY_DAYS * MS_PER_DAY;

    const dataToStore = {
      data: leadData,
      expiresAt,
    };

    localStorage.setItem('leadInfo', JSON.stringify(dataToStore));
  } catch (error) {
    console.error('Error saving lead info to localStorage:', error);
  }
};

export const getFormData = () => {
  const shouldPrefill = process.env.REACT_APP_PREFILL_FORM_FOR_TESTING === 'true';

  if (shouldPrefill) {
    return {
      firstName: 'John',
      lastName: 'Doe',
      email: 'john.doe@example.com',
      phone: '555-123-4567',
    };
  }

  const savedLeadInfo = loadSavedLeadInfo();
  if (savedLeadInfo) {
    return savedLeadInfo;
  }

  return {};
};

export const saveConversationToStorage = (
  sessionId,
  messageHistory,
  conversationState,
  formData,
  amenityPlaces,
) => {
  const conversationData = {
    sessionId,
    userInteractions: messageHistory.filter((m) => m.type === 'user').length,
    messages: messageHistory,
    conversationState,
    formData,
    amenityPlaces,
  };

  localStorage.setItem(`chatbot_conversation_${sessionId}`, JSON.stringify(conversationData));

  const allConversations = JSON.parse(localStorage.getItem('chatbot_all_conversations') || '[]');
  const existingIndex = allConversations.findIndex((conv) => conv.sessionId === sessionId);

  if (existingIndex >= 0) {
    allConversations[existingIndex] = conversationData;
  } else {
    allConversations.push(conversationData);
  }

  localStorage.setItem('chatbot_all_conversations', JSON.stringify(allConversations));
};

